'use client'
import { axiosAdmin } from '@/lib/axios'
import { useAuthStore } from '@/store/AuthStore'
import { useQuery } from '@tanstack/react-query'

export function useGetCartItems() {
	const accessToken = useAuthStore((state) => state.accessToken);
	return useQuery({
		queryKey: ['getcart'],
		queryFn: async () => {
			try {
				const response = await axiosAdmin.get('/user/cart')
				return response?.data
			} catch (error) {
				console.log('err', error)
				throw error
			}
		},
		enabled: Boolean(accessToken), // Reactive: updates when user logs in/out
	})
}

export function useGetAllAddresses() {
	const accessToken = useAuthStore((state) => state.accessToken);
	return useQuery({
		queryKey: ['getAddresses'],
		queryFn: async () => {
			try {
				const response = await axiosAdmin.get('/user/addresses')
				console.log(response?.data)
				return response?.data
			} catch (error) {
				console.log('err', error)
				throw error
			}
		},
		enabled: Boolean(accessToken), // Reactive: updates when user logs in/out
	})
}

export function useGetGuestCart(items: any[]) {
	// Only run if there are items and not logged in (handled by enabled arg usually, but here we just check length)
	// We might want to pass enabled from component
	return useQuery({
		queryKey: ['guestCart', items],
		queryFn: async () => {
			if (!items || items.length === 0) return { items: [], baseCartTotal: 0, preview: {} };
			// Prepare items payload: { productId, variantId, quantity }
			const payload = items.map((item: any) => ({
				productId: item.product._id,
				variantId: item.variant?._id || null,
				quantity: item.quantity
			}));
			
			try {
				const response = await axiosAdmin.post('/user/cart/guest-cart', { items: payload })
				return response?.data
			} catch (error) {
				console.log('err', error)
				throw error
			}
		},
		enabled: items.length > 0,
		staleTime: 1000 * 60 * 5, // Cache for 5 mins
	})
}
